module.exports = __webpack_public_path__ + "img/pr-11.760bfe1a.png";